/**
 * @desc 分页
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierBankAccount.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierBankAccount/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
